console.log('%cstoreroom-search.js', 'color: yellow', Math.random());

import * as Vue from 'vue';
import {createPinia, setMapStoreSuffix} from 'pinia';
import axios from 'axios';
import VueAxios from 'vue-axios';
import velocity from 'velocity-animate'
import DStoreroomSearch from '@components/organisms/DStoreroomSearch.vue';
import vClickOutside from 'click-outside-vue3';
import VueSmoothScroll from 'vue3-smooth-scroll';
import Notifications from '@kyvg/vue3-notification';

$(window).on('load', function() {
    try {
        const mountEl = document.querySelector('#storeroom-search');
        setMapStoreSuffix('');
        const pinia = createPinia();
        const app = Vue.createApp(DStoreroomSearch, {...mountEl.dataset});
        app.use(vClickOutside);
        app.use(VueAxios, axios);
        app.use(VueSmoothScroll);
        app.use(Notifications, { velocity });
        app.use(pinia);
        app.mount('#storeroom-search');
    }
    catch (e) {
        console.error('%cstoreroom-search error: ', 'color: yellow', e);
    }

});

$('body').on('click', '[data-switch-view]', function() {
    $(this).toggleClass('_list');
    $('[data-switch-button]').toggleClass('_active');
    $('[data-switch-content]').toggleClass('_list');
    $('[data-sorter-drop]').toggleClass('_hide');
});

